import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 md:py-24" data-id="element-162" data-mp="122vf0mmg35sn">
      <div className="mx-auto max-w-3xl" data-id="element-163" data-mp="1prxupoxiqoki">
        <SectionHeading eyebrow="Questions" title="Frequently asked questions" data-id="element-164" data-mp="1pszechslojdu" />
        <ul className="mt-10 space-y-3" data-id="element-165" data-mp="1uqr87hct2fko">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="rounded-2xl bg-paper" data-id="element-166" data-mp="1l1hgi2lviyx3" data-mpi={i}>
                <h3 data-id="element-167" data-mp="1kzwn4gbapm0t">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-serif text-lg font-bold text-ink md:text-xl" data-id="element-168" data-mp="1kzef6mf9tjd2">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-brand-sage transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-169" data-mp="2js74vq5unruf" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-170" data-mp="37fxbhj4ss5b8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-171" data-mp="32hvr8uvmxzy6">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink/80" data-id="element-172" data-mp="1n153vjcqaitt">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <div className="mt-10" data-id="element-173" data-mp="2br9edfgmo92n">
          <CtaButton label="I'm Ready — Give Me Access" data-id="element-174" data-mp="2bskgzbyc7as6" />
        </div>
      </div>
    </section>;
}